import { render, staticRenderFns } from "./QuoteCommunications.vue?vue&type=template&id=6626e43c&scoped=true"
import script from "./QuoteCommunications.vue?vue&type=script&lang=js"
export * from "./QuoteCommunications.vue?vue&type=script&lang=js"
import style0 from "./QuoteCommunications.vue?vue&type=style&index=0&id=6626e43c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6626e43c",
  null
  
)

export default component.exports